import { useTranslation } from 'react-i18next'

import { useDispatch } from 'react-redux'

import { useLocation } from 'react-router-dom'

import { useChatTranslations } from '@app/components/Chat/useChatTranslations'

import config from '@app/config'
import { useUser, useLanguages } from '@app/hooks'
import { trackSavingPreferences } from '@app/services/tracking'
import { AppDispatch } from '@app/store'
import { patchLanguageExceptionsThunk } from '@app/store/user'

import { Modal, Switcher } from '@lib/components'

import styles from './styles.module.scss'
import { TranslationDrawerProps } from './types'

export const TranslationDrawer = ({
  onClose,
  translationEnabled,
  language,
  conversation,
}: TranslationDrawerProps) => {
  const { t } = useTranslation()
  const location = useLocation()
  const { currentUser } = useUser()
  const dispatch: AppDispatch = useDispatch()
  const { fetchTranslations } = useChatTranslations()
  const userState = useUser()
  const { languages } = useLanguages()

  const regionalSettingsLink = `${config.identity.isBackOffice ? config.identity.website : config.identity.dashboardUrl}/my-profile/settings?returnurl=${location.pathname}`

  const handleTranslationSwitch = async () => {
    const lang = languages.find((l) => l.name === language)?.id || ''
    await dispatch(
      patchLanguageExceptionsThunk({
        userId: currentUser.id,
        language: lang,
      })
    )
    trackSavingPreferences(
      config.regionalSettings?.languageExceptions || [],
      translationEnabled ? [] : [lang],
      translationEnabled ? [lang] : []
    )
    if (!translationEnabled) {
      fetchTranslations(conversation)
    }
  }

  return (
    <Modal
      onClose={onClose}
      isOpen={true}
      title={t('Chat.TranslationDrawer.Title')}
      isFullScreen={false}
      showBottomCloseButton={false}
      headerClassName={styles.modalHeader}
      className={styles.modal}
    >
      <div className={styles.translateFrom}>
        <span>{t('Chat.TranslationDrawer.TranslateFrom', { language })}</span>
        <Switcher
          disabled={userState.patchingCurrentUser}
          label={t('Chat.TranslationDrawer.TranslateFrom', { language })}
          checked={translationEnabled}
          onChange={handleTranslationSwitch}
        />
      </div>
      <div
        className={styles.language}
        dangerouslySetInnerHTML={{
          __html: t('Chat.TranslationDrawer.Description', {
            regionalSettingsLink,
          }),
        }}
      />
    </Modal>
  )
}
